module.exports = __webpack_public_path__ + "img/about1.f35f2cef.jpg";